import ReactDOM from 'react-dom'

import GroupsPerformance from './performance'
import { GroupRow } from './types'

window['FinvizInitGroupsPerformance'] = function (rows: GroupRow[]) {
  ReactDOM.render(<GroupsPerformance rows={rows} />, document.getElementById('groups'))
}
